/*
 * @description: 本地存储 操作
 * @Author: Jay
 * @Date: 2022-06-13 11:56:01
 * @LastEditors: Jay
 * @LastEditTime: 2026-02-28 16:38:23
 */

/*
    本地存储
*/
export const storage = {
    //存储
    set(key, value) {
        window.localStorage.setItem(key, JSON.stringify(value))
    },
    //取出数据
    get(key) {
        const value = window.localStorage.getItem(key)
        if (value && value != "undefined" && value != "null") return JSON.parse(value)
        else return null
    },
    // 删除数据
    remove(key) {
        window.localStorage.removeItem(key)
    }
};

/*
    会话存储
 */
export const sessionStorage = {
    //存储
    set(key, value) {
        window.sessionStorage.setItem(key, JSON.stringify(value))
    },
    //取出数据
    get(key) {
        const value = window.sessionStorage.getItem(key);
        if (value && value != "undefined" && value != "null") return JSON.parse(value)
        return null
    },
    // 删除数据
    remove(key) {
        window.sessionStorage.removeItem(key)
    }
}